import { collection, doc, getDoc, where } from "@firebase/firestore";
import { db } from "../../../firebase";

const GetSingleExam = async (ExamID) => {
  try {
    const ExamsCollection = collection(db, "Exams");
    const ExamDocument = doc(ExamsCollection, ExamID);
    const ExamSnapshot = await getDoc(
      ExamDocument,
      where("IsDeleted", "==", false)
    );

    let Exam = { ...ExamSnapshot.data(), id: ExamSnapshot.id };

    return Exam;
  } catch (error) {
    console.log(error);
  }
};

export default GetSingleExam;
